import {
  AiOrderEntryRequest,
  DocumentProperties,
  DocumentUploadUrlResponse,
} from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'orders/ai-entry';

export class AiOrderEntryController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async find(): Promise<AiOrderEntryRequest[]> {
    const response = await this.http.get<AiOrderEntryRequest[]>('');
    return response.data.map((request) => new AiOrderEntryRequest(request));
  }

  async getUploadUrl(
    fileName: string,
    contentType: string,
  ): Promise<DocumentUploadUrlResponse> {
    const response = await this.http.post<DocumentUploadUrlResponse>(
      'upload-url',
      { fileName, contentType },
    );
    return new DocumentUploadUrlResponse(response.data);
  }

  async submit(
    clientId: number,
    instructions: string,
    documents: DocumentProperties[],
  ): Promise<AiOrderEntryRequest> {
    const response = await this.http.post<AiOrderEntryRequest>('', {
      clientId,
      instructions,
      documents,
    });
    return new AiOrderEntryRequest(response.data);
  }
}
